import React from 'react';
import { FormGroup } from 'react-bootstrap';
import { Form, Validator } from '../widgets';

const EquipmentDate = props => (
    <Form.Cell>
        <FormGroup>
            <Validator validation={props.validation}>
                <Form.Label>{props.name}{props.required ? <Validator.Mand /> : <></>}</Form.Label>
                <Form.Control type="date" name={props.key_name} id={props.id} placeholder="DD/MM/YYYY" format="DD/MM/YYYY" onChange={props.onChange} />
                <Validator.Text />
            </Validator>
        </FormGroup>
    </Form.Cell>
);

export default EquipmentDate;